import React from 'react'
import ReactDOM from 'react-dom/client'

import { App } from '@/customer/app'
import { initPostHog } from '@/customer/lib/posthog'
import { initSentry } from '@/customer/lib/sentry'
import '@/customer/styles/globals.css'

initSentry()
initPostHog()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
